import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../../Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { VentasComponent } from '../../informes/ventas/ventas.component';
import { ComprasComponent } from '../../compras/compras.component';
import { ComprasinfComponent } from '../../informes/compras/comprasinf.component';
import { KardexComponent } from '../../informes/kardex/kardex.component';
import { VentasClientesComponent } from '../../informes/ventas-clientes/ventas-clientes.component';
import { SelectSucursalComponent } from '../../select-sucursal/select-sucursal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VentasPorHoraVendedorComponent } from '../../informes/ventas-por-hora-vendedor/ventas-por-hora-vendedor.component';
import { ListaSaldosComponent } from '../../lista-saldos/lista-saldos.component';
import { PrintReporteGastosDetalladoComponent } from '../../print-reporte-gastos-detallado/print-reporte-gastos-detallado.component';
import { PrintReporteUtilidadesComponent } from '../../print-reporte-utilidades/print-reporte-utilidades.component';
interface ManagedWindow {
  [key: string]: Window | null;
}

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  public nombre;
  public usuario: Usuario = new Usuario();
  public nivel: any;
  public islogin: boolean = false;
  public sucursal: string = "";
  private windowManager: ManagedWindow = {};
  @ViewChild(VentasComponent, null) modalventas: VentasComponent;
  @ViewChild(ComprasinfComponent, null) modalcompras: ComprasinfComponent;
  @ViewChild(KardexComponent, null) modalkardex: KardexComponent;
  @ViewChild(VentasClientesComponent, null) modal_Ventas_clientes: VentasClientesComponent;
  @ViewChild(SelectSucursalComponent, null) modal_sucursal: SelectSucursalComponent;

  @ViewChild(ListaSaldosComponent, null) modal_listasaldos: ListaSaldosComponent;
  @ViewChild(PrintReporteGastosDetalladoComponent, null) printgastosdetallado: PrintReporteGastosDetalladoComponent;
  @ViewChild(PrintReporteUtilidadesComponent, null) printreporteutilidades: PrintReporteUtilidadesComponent;
  constructor(private auth: AuthService, private data: DataService, private modalService: NgbModal) { }

  async ngOnInit() {
    if (this.auth.getCurrentUser() != undefined) {
      this.usuario = this.auth.getCurrentUser();
      this.data.getSucursalObj().subscribe((nombre) => {
        this.sucursal = nombre;
      });
      console.log(this.sucursal);

    }
    else { this.usuario = new Usuario(); }
  }
  logout() {
    this.auth.logoutUser();
  }
  cerrar_sistema() {
    this.auth.logoutUser();
  }

  isLogin() {
    if (this.auth.getCurrentUser() != undefined) {
      return true;
    } else { return false; }
  }

  showmodal_infventas() {
    this.modalventas.show(() => {
    })
  }

  showmodal_infcompras() {
    this.modalcompras.show(() => {
    })
  }

  showmodal_kardex() {
    this.modalkardex.show(() => {
    })
  }

  show_informesventas() {
    this.modal_Ventas_clientes.show(() => {
    })
  }

  show_sucursal() {
    if (this.usuario.idpersonal.idnivel == 1) {
      this.modal_sucursal.show(() => {
      })
    }
  }

  show_ventasporhora_vendedor() {
    const modalRef = this.modalService.open(VentasPorHoraVendedorComponent, {
      windowClass: 'modal-animado', // ← Usar windowClass para animaciones
      backdropClass: 'backdrop-animado',
      centered: true,

    });
  }

  openLink(route: string): void {
    // Normaliza el nombre de la ventana
    const windowName = route.replace(/\//g, '_');
    const winRef = this.windowManager[windowName];
    const baseUrl = window.location.origin;

    // Construye la URL completa
    let fullUrl: string;

    if (route === '') {
      fullUrl = `${baseUrl}`;
    } else if (route.startsWith('/')) {
      fullUrl = `${baseUrl}${route}`;
    } else {
      fullUrl = `${baseUrl}/${route}`;
    }

    // Verificar si la ventana existe y no está cerrada
    if (winRef && winRef.closed === false) {
      // Enfoca la ventana existente SIN recargar
      winRef.focus();

      // No actualices la URL ni recargues
      // Solo mantén el foco en la ventana existente
    } else {
      // Abre nueva ventana
      this.windowManager[windowName] = window.open(fullUrl, windowName);
    }
  }

  // Limpiar referencias de ventanas cerradas
  trackClosedWindows() {
    setInterval(() => {
      for (const key in this.windowManager) {
        if (this.windowManager.hasOwnProperty(key)) {
          const win = this.windowManager[key];
          if (win && win.closed) {
            this.windowManager[key] = null;
          }
        }
      }
    }, 5000);
  }

  show_listaprecios() {
    this.modal_listasaldos.ImprimirSaldos()

  }

  show_reporte_gastos_detallado() {
    this.printgastosdetallado.show(() => {
      
    })
  }

  show_reporte_utilidades() {
    this.printreporteutilidades.show(() => {
      
    })
  }

}
